import {
  DrawerBackdrop,
  DrawerBody,
  DrawerCloseTrigger,
  DrawerContent,
  DrawerRoot,
  DrawerTrigger,
} from "@/components/ui/drawer"
import { Box, Flex, Image, Text, useDisclosure } from "@chakra-ui/react"
import { useQueryClient } from "@tanstack/react-query"
import { useTranslation } from "react-i18next"
import { FiLogOut, FiMenu } from "react-icons/fi"

import type { UserPublic } from "@/client"
import { useColorModeValue } from "@/components/ui/color-mode"
import useAuth from "@/hooks/useAuth"
import LogoLight from "/qdat-logo-light.svg"
import Logo from "/qdat-logo.svg"
import { Button } from "../ui/button"
import { CollapsibleSidebar } from "./CollapsibleSidebar"
import SidebarItems from "./SidebarItems"

export const SidebarMobile = () => {
  const queryClient = useQueryClient()
  const currentUser = queryClient.getQueryData<UserPublic>(["currentUser"])
  const { open, onClose, onToggle } = useDisclosure()
  const { logout } = useAuth()
  const { t } = useTranslation("common")
  const currentLogo = useColorModeValue(LogoLight, Logo)

  const handleLogout = async () => {
    logout()
  }

  return (
    <>
      {/* Mobile */}
      <DrawerRoot open={open} placement="start" onOpenChange={onToggle}>
        <DrawerBackdrop />
        <DrawerTrigger asChild display={{ base: "flex", md: "none" }}>
          <Button
            aria-label="Open Menu"
            variant="ghost"
            fontSize="22px"
            minW="44px"
            h="44px"
            m={1}
          >
            <FiMenu />
          </Button>
        </DrawerTrigger>
        <DrawerContent
          maxW={{ base: "280px", sm: "320px" }}
          display={{ base: "flex", md: "none" }}
        >
          <DrawerCloseTrigger />
          <DrawerBody py={8}>
            <Flex flexDir="column" justify="space-between">
              <Box>
                <Image src={currentLogo} alt="QDat logo" p={6} />
                <SidebarItems onClose={onClose} />
                <Flex
                  as="button"
                  onClick={handleLogout}
                  p={2}
                  colorScheme="red"
                  fontWeight="bold"
                  alignItems="center"
                >
                  <FiLogOut />
                  <Text ml={2}>{t("nav.logOut")}</Text>
                </Flex>
              </Box>
              {currentUser?.email && (
                <Text lineClamp={2} fontSize="sm" p={2}>
                  {t("nav.loggedInAs")} {currentUser.email}
                </Text>
              )}
            </Flex>
          </DrawerBody>
        </DrawerContent>
      </DrawerRoot>
    </>
  )
}

export const SidebarDesktop = () => {
  return (
    <Box display={{ base: "none", md: "flex" }} position="relative">
      <CollapsibleSidebar />
    </Box>
  )
}
